import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { ContactFragmentDoc } from '../../fragments/__generated__/contact';
import { ProviderFieldsFragmentDoc } from '../../fragments/__generated__/providerFields';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentProviderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentProviderQuery = { __typename?: 'Query', currentProvider?: { __typename?: 'Provider', fileUuidIds?: Array<string> | null, activeChangeRequestId?: number | null, id: number, state: string, competenceFilled?: boolean | null, onboardingCompleted?: boolean | null, publicComment?: string | null, primaryContactId?: number | null, name: string, legalName?: string | null, email?: string | null, vatId?: string | null, notVatPayer: boolean, phone?: string | null, website?: string | null, pincode?: string | null, locale?: string | null, bankAccount?: string | null, bankName?: string | null, bankCode?: string | null, bankAccountHolderName?: string | null, bankCountry?: string | null, isEuropean?: boolean | null, isLocal?: boolean | null, isRfqReady?: boolean | null, poNumberLimit?: number | null, poValueLimit?: number | null, acceptSelfBilling: boolean, freeCapacity: boolean, freeCapacityFreezeUntil?: string | null, financeCheckAt?: string | null, limitsComment?: string | null, gstIn?: string | null, sgTermsAccepted: boolean, vietnamMigrationEuErpId?: number | null, billingAddress: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, region?: string | null, zip?: string | null }, contacts: Array<{ __typename?: 'Contact', active?: boolean | null, phone?: string | null, phone2?: string | null, position?: string | null, viber?: string | null, whatsapp?: string | null, id: number, firstName: string, lastName: string, locale?: Types.ProvidersContactsLocaleEnumType | null, email: string, telegram?: string | null, wechat?: string | null, preferredContactType?: string | null }>, performance?: { __typename?: 'Performance', ordersInProductionCount?: number | null, ordersInProductionValue?: number | null, totalOrdersCount?: number | null, totalOrdersValue?: number | null } | null, rank?: { __typename?: 'Rank', cancelRatio?: number | null, commIssuesRatio?: number | null, communication?: number | null, overdueRatio?: number | null, packFailRatio?: number | null, packing?: number | null, poQuantity?: number | null, quality?: number | null, qualityRatio?: number | null, timing?: number | null, total?: number | null } | null, shippingAddress: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, region?: string | null, zip?: string | null }, tags: Array<{ __typename?: 'Tag', context: string, en?: string | null, id: number, name: string, tr?: string | null }> } | null };


export const CurrentProviderDocument = gql`
    query currentProvider {
  currentProvider {
    billingAddress {
      address
      city
      country
      region
      zip
    }
    contacts {
      active
      ...contact
      phone
      phone2
      position
      viber
      whatsapp
    }
    fileUuidIds
    performance {
      ordersInProductionCount
      ordersInProductionValue
      totalOrdersCount
      totalOrdersValue
    }
    ...providerFields
    rank {
      cancelRatio
      commIssuesRatio
      communication
      overdueRatio
      packFailRatio
      packing
      poQuantity
      quality
      qualityRatio
      timing
      total
    }
    shippingAddress {
      address
      city
      country
      region
      zip
    }
    tags {
      context
      en
      id
      name
      tr
    }
  }
}
    ${ContactFragmentDoc}
${ProviderFieldsFragmentDoc}`;

/**
 * __useCurrentProviderQuery__
 *
 * To run a query within a React component, call `useCurrentProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentProviderQuery(baseOptions?: Apollo.QueryHookOptions<CurrentProviderQuery, CurrentProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentProviderQuery, CurrentProviderQueryVariables>(CurrentProviderDocument, options);
      }
export function useCurrentProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentProviderQuery, CurrentProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentProviderQuery, CurrentProviderQueryVariables>(CurrentProviderDocument, options);
        }
export type CurrentProviderQueryHookResult = ReturnType<typeof useCurrentProviderQuery>;
export type CurrentProviderLazyQueryHookResult = ReturnType<typeof useCurrentProviderLazyQuery>;
export type CurrentProviderQueryResult = Apollo.QueryResult<CurrentProviderQuery, CurrentProviderQueryVariables>;